<template>
<div>
    <Modal
         class-name="vertical-center-modal"
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'700px'}">
        <div style="overflow:hidden">

        <div class="messageList">
            <ul >
                <li class="" v-for="(item,index) in detailList" :key='index' :class="[item.feedbackBy==2?'feedbackByAdmin':'']">
                    <div class="topInfo flex">
                        <div>{{item.feedbackName}}</div>
                        <div>{{item.feedbackTime}}</div>
                    </div>
                    <div class="message">{{item.message}}</div>
                </li>
            </ul>
        </div>
        </div>

        <div style="text-align:center">
            <Input  maxlength="500"  show-word-limit  type="textarea" v-model.trim="formData.message" :placeholder="$t('inputPlaceholder')" style="margin-top:20px"></Input>
            <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px;margin-top:20px">{{$t('feedBack.detailModel.reply')}}</Button>
        </div>
        
    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import { mapState } from 'vuex'

    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        components: {
        },
        data() {
            return {   
                detailList:[],
                title: '',//弹框标题
                formData:{
                    message:'',
                    feedbackBy:2
                },
                totalNum:'20',
                disabled: false,//禁用确定按钮
            }
        },
        watch:{
            showModel(val){
                if(val){
                    this.getData(this.editFormData.id)
                }
            },
        },
        computed:{
            ...mapState(['local','selectId']),

        },
        created(){
            
        },
        methods: {
            getData(id){
                let params= {
                    feedbackGroupId:id,
                    dealerId:this.selectId
                    // id:id
                }
                
                this.axios.post(this.config.urlArray.messageGroupInfo, params).then((result) => {
                    common.ajaxMsg(result.data);
        
                    let resData = result.data.data
                    resData = resData.map((item,index)=>{
                        let obj = {'1':this.$t('feedBack.User'),2:this.$t('feedBack.Admin')}
                        item.feedbackName = obj[item.feedbackBy]
                        return item
                    })

                    //处理数组
                    this.detailList  = resData
                    this.loading = false
                }).catch((err) => {
                    common.msg('error','failed',()=>{this.loading = false})
                });
            },
            subData() {//提交表单
                if(!this.formData.message){
                    let stext = this.$t('required');
                    // if(this.local=='zh-CN'){
                    //     stext = '文字必须填写'
                    // }else{
                    //     stext = 'Mandatory fields cannot be empty'
                    // }
                    common.msg('error',stext,()=>{this.disabled = false;})
                    return
                }
                this.disabled = true;

                setTimeout(() => {
                    this.disabled = false;
                }, 2000);

                this.axios.post(this.config.urlArray.messageGroupReply, {...this.formData,dealerId:this.selectId,feedbackGroupId:this.editFormData.id}).then((result) => {
                    common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                        this.resetForm();//重置表单
                        this.fn()
                    },()=>{this.disabled = false; })

                    
                }).catch((err) => {
                    this.disabled = false;
                    common.msg('error','failed',()=>{this.disabled = false;})
                });
                        
               
            },
            openOrClose(value) {
                if(value === true) {        
                    this.title = this.$t('feedBack.detailModel.title')
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                }
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                this.formData.message = ''
            }
        }
    }
</script>
<style lang="less" scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
.totalNum{
    margin-top: 20px;
    font-weight: bold;
}
.messageList{
    max-height: 400px;
    min-height: 400px;
    padding: 0 30px;
     // overflow-y: scroll;
    overflow: auto;
}

li{
    border: 1px solid #999;
    padding: 6px;
    border-radius: 6px;
    margin-bottom: 20px;
}
.feedbackByAdmin{
    background-color: #9EEA6A;
    border: 1px solid #9EEA6A;
}
.topInfo{
    justify-content: space-between;
}


</style>